import { CATALOG_ROUTES, ORDER_GUIDE_ROUTES } from '@/navigators/routes';
import { CatalogCategoryType } from '@/contexts/item-context-types';
import { CatalogStackParams, OrderGuideStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';

export enum SearchEntryPoint {
  CATALOG = 'catalog',
  ORDER_GUIDE = 'order_guide',
}

// Props for Order Guide stack usage
export type OrderGuideUnifiedSearchScreenProps = StackScreenProps<
  OrderGuideStackParams,
  ORDER_GUIDE_ROUTES.OrderGuideUnifiedSearch
>;

// Props for Catalog stack usage
export type CatalogUnifiedSearchScreenProps = StackScreenProps<
  CatalogStackParams,
  CATALOG_ROUTES.CatalogUnifiedSearch
>;

// Union type to support both stacks
export type UnifiedSearchScreenProps =
  | OrderGuideUnifiedSearchScreenProps
  | CatalogUnifiedSearchScreenProps;

// Shared component logic
export interface UnifiedSearchScreenComponentProps {
  category?: CatalogCategoryType;
  navigation: UnifiedSearchScreenProps['navigation'];
  searchEntryPoint?: SearchEntryPoint;
}
